import {
    RESET_CITIES,
    RESET,
    SELECT_MENU,
    HANDLE_CHANGE,
    SELECT_PLAN,
    SUM_ASSURED,
    CONFIRM_CODE,
    POST_DATA,
    LOADING,
    GLOBAL_SHOW,
    ADMIN_CHANGE,
    SET_POLIZA,
    SET_CURRENT_PAGE,
    SET_POL_FILTERS,
    SET_CODEMP,
    SET_POL,
    SET_SIN_FILTERS,
    RESET_STATICS,
    CHANGE_LAST_STATE,
    ALERT_DATA,
} from './types';
export {
    searchCities,
    logIn,
    searchModels,
    saveMenu,
    saveTitularData,
    saveHomeData,
    saveVehicleData,
    savePayMethod,
    saveBeneficiary,
    saveTecnologyData,
    cancelPol,
    searchCotizacion,
    getInfoUser,
    updateInfoUser,
} from './webServices';
export {
    getPolicies,
    getPolicy,
    updatePolicy,
    getStatics,
    updateUsers,
    deleteUsers,
    updateSucursales,
    deleteSucursales,
    updateRegions,
    deleteRegions,
    updateZones,
    deleteZones,
    getSinisters,
    deleteSinister,
} from './admin';

export function handleChange(e) {
    return {
        type: HANDLE_CHANGE,
        payload: e,
    };
};

export function handleChangeAdmin(payload) {
    return {
        type: ADMIN_CHANGE,
        payload,
    };
};

export function handleChangeLastState(payload) {
    return {
        type: CHANGE_LAST_STATE,
        payload,
    };
};

export function changeSumAssured(sum) {
    return {
        type: SUM_ASSURED,
        payload: sum,
    };
};

export function selectMenu({ value, id, codcia, haveDiscount, msgpde }) {
    return {
        type: SELECT_MENU,
        payload: { value, id, codcia, haveDiscount, msgpde }
    };
};

export function selectPlan(plan, codpro, price, sumAssured) {
    return {
        type: SELECT_PLAN,
        payload: { plan, codpro, price, sumAssured },
    };
};

export function logOut() {
    // localStorage.removeItem('email');
    localStorage.removeItem('hash');
    localStorage.removeItem('date');
    window.location.reload();
};

export function resetData(data) {
    return {
        type: RESET,
        payload: { resetCodpmpol: data },
    };
};

export function resetError(payload) {
    return {
        type: ALERT_DATA,
        payload: { codpmpol: payload, error: '', status: ''},
    };
};


export function resetStatics() {
    return {
        type: RESET_STATICS,
    };
}

export function resetCities() {
    return {
        type: RESET_CITIES,
    }
}

export function loadConfirmCode(data) {
    return {
        type: CONFIRM_CODE,
        payload: data,
    };
};

export function resetCodpmpol() {
    return {
        type: POST_DATA,
        payload: '',
    };
};

export function setLoading(bool) {
    return {
        type: LOADING,
        payload: !(bool === false),
    };
};

export function handleShowState(bool) {
    return {
        type: GLOBAL_SHOW,
        payload: bool,
    };
};

export function setPolizas(pol) {
    return {
        type: SET_POLIZA,
        payload: pol,
    };
};

export function setCurrentPage(page) {
    return {
        type: SET_CURRENT_PAGE,
        payload: page,
    }
}

export function setPolFilters(payload) {
    return {
        type: SET_POL_FILTERS,
        payload,
    }
}

export function setSinFilters(payload) {
    return {
        type: SET_SIN_FILTERS,
        payload,
    }
}

export function setCodemp(payload) {
    return {
        type: SET_CODEMP,
        payload,
    }
}

export function setPol(payload) {
    return {
        type: SET_POL,
        payload
    };
}
